import { create, } from "zustand";
import { devtools, } from "zustand/middleware";
import { IPhoneFormSlice, phoneFormSliceCreator, } from "./slices/phoneFormSliceCreator";
import { ISMSFormSlice, smsFormSliceCreator, } from "./slices/smsFormSliceCreator";
import { IPassportFormSlice, passportFormSliceCreator, } from "./slices/passportFormSliceCreator";

export type LoginFormState = IPhoneFormSlice & ISMSFormSlice & IPassportFormSlice;

export const useLoginFormStore = create<LoginFormState>()(
  devtools(
    (...a) => ({
      ...phoneFormSliceCreator(...a,),
      ...smsFormSliceCreator(...a,),
      ...passportFormSliceCreator(...a,),
    }),
    { name: "login-store", },
  ),
);
